<ng-container *ngIf="form">
    <app-select
      [form]="form"
      label="{{ 'SOURCE' | translate }}"
      [className]="className"
      [controlName]="controlName"
      [items]="[
        { id: rosterUploadFileType.Automatic, name: 'SERVER_FILE' | translate },
        { id: rosterUploadFileType.Manual, name: 'MANUAL' | translate },
        { id: rosterUploadFileType.GroupOfGroups, name: 'GROUP_OF_GROUPS' | translate },
        { id: rosterUploadFileType.External, name: 'AUTO_SYNC' | translate },
      ]"
    >
    </app-select>
  </ng-container>